/*=========================================================*/
// route.hidden 如果设置为true，则不会显示在tabs菜单中，侧边栏也不会展示
// route.meta.affix 如果设置为true，则标签不可关闭
/*=========================================================*/

// 1.Dependency
import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import { filter, flatten } from "lodash";
import User from "@/utils/user.js";
import { getPageTitle } from "@/utils/common";
import store from "../store";
const DEV = process.env.NODE_ENV === "development";

// 2.Routes
const files = require.context("./", true, /\.js$/);
const routesModules = files.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    const value = files(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});

export const constantRoutes = [
    ...flatten(
        filter(routesModules, (module) => {
            return module;
        })
    ),
];

// 4.Build An Instance
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // history:createWebHashHistory()
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
    document.title = getPageTitle(to.meta.title);

    const urlToken = to.query.__token;
    if (urlToken) {
        // 直接设置token到localStorage，覆盖任何现有登录状态
        localStorage.setItem(User.TOKEN_KEY, urlToken);
        localStorage.setItem(User.LAST_AUTH, Date.now());
        localStorage.setItem("logged_in", "true");
        localStorage.setItem("panel", User.DEFAULT_PANEL); // 设置默认面板，isLogin方法需要此字段

        // 清除URL中的token参数（避免泄露）
        const newQuery = { ...to.query };
        delete newQuery.__token;
        if (Object.keys(newQuery).length === 0) {
            // 如果没有其他查询参数，直接替换当前路由
            next({ path: to.path, replace: true });
            return;
        } else {
            // 保留其他查询参数
            next({ path: to.path, query: newQuery, replace: true });
            return;
        }
    }

    // 检查是否过期
    if (User.isExpired()) User.destroy();

    const isLogin = User.isLogin();
    if (isLogin) {
        await store.dispatch("app/loadMyPermission");
    }
    if (to.path === "/login") {
        next();
    } else if (!isLogin && !to.meta.isPublic) {
        next({ name: "login", query: { redirect: to.fullPath } }); // 未登录且非公开页面，跳转到登录
    } else if (to.path.startsWith("/webview/")) {
        // webview页面进入webview_layout单独处理权限
        next();
    } else if (hasPermission(to)) {
        store.commit("permission/CHANGE_HAS_PERMISSION", true);

        store.commit("permission/SET_ACTIVE_MENU", to?.meta?.parent);

        store.dispatch("permission/generateRoutes", User.getGroup());

        next(); // 有权限，继续导航
    } else {
        store.commit("permission/CHANGE_HAS_PERMISSION", false);
        next(false); // 无权限，提示无权限
    }
});

// 检查权限
function hasPermission(to) {
    const isSuperAdmin = User.isSuperAdmin();
    const myPermission = User.getPermission() || [];
    const metaGroup = to.meta.group;
    const metaPermission = to.meta.permission || "";
    const permissionsAny = to.meta.permissionsAny || [];
    const myGroup = User.getGroup();

    // 如果是公开页面，可访问
    if (to.meta.isPublic) return true;
    // 如果meta没有设置role 和 permission 正常显示
    if (!metaGroup && !metaPermission && !permissionsAny.length) return true;
    // 如果是超级管理员，可访问
    if (isSuperAdmin) return true;
    // 如果有设置页面权限且我的权限组大于等于页面权限组，可访问
    if (metaGroup && myGroup >= metaGroup) return true;
    // 如果设置权限且我的权限列表中有该权限，可访问
    if (metaPermission && myPermission.some((item) => item.action === metaPermission)) return true;
    if (permissionsAny.some((action) => myPermission.some((item) => item.action === action))) return true;

    return false;
}

export default router;
